import { resetGatewaysState } from '@common/modules/gateways/stores/gateways.actions'
import type { Project } from '@common/modules/projects'
import { getCurrentProject } from '@common/modules/projects/stores/projects.actions'
import { useProjectsStore } from '@common/modules/projects/stores/projects.store'
import { updateWorkspaceContext } from '@common/modules/user'
import { setLastUsedWorkspaceIdOnCurrentUser } from '@common/modules/user/utils/setLastUsedWorkspaceIdOnCurrentUser'
import type { Workspace } from '@common/modules/workspaces'
import { updateLastUsedProject } from '@common/modules/workspaces/stores/workspaces.actions'
import { useWorkspacesStore } from '@common/modules/workspaces/stores/workspaces.store'

export async function switchWorkspace(workspace: Workspace): Promise<Project | null> {
  resetGatewaysState()
  useProjectsStore.getState().setState({ isResolvingWorkspaceProject: true })
  useProjectsStore.getState().setCurrentProject(null)
  useWorkspacesStore.getState().setCurrentWorkspace(workspace)
  setLastUsedWorkspaceIdOnCurrentUser(workspace.id)

  try {
    await updateWorkspaceContext(workspace.id)

    await getCurrentProject(workspace.id)

    const currentProject = useProjectsStore.getState().currentProject
    if (currentProject?.id) {
      if (workspace.lastUsedProjectId !== currentProject.id) {
        void updateLastUsedProject(workspace.id, currentProject.id)
      }
    } else if (workspace.lastUsedProjectId) {
      void updateLastUsedProject(workspace.id, workspace.lastUsedProjectId)
    }

    return currentProject
  } finally {
    useProjectsStore.getState().setState({ isResolvingWorkspaceProject: false })
  }
}
